import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IPlanCategory } from '../interfaces';
import { PlanCategoryMapper } from '../mappers';

export type IGetPlanCategoriesRepoResponse = IRepoResponse<200, { data: IPlanCategory[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetPlanCategoriesRepo = IRepo<[], IGetPlanCategoriesRepoResponse>;

export const GetPlanCategoriesRepoType = Symbol.for('GetPlanCategoriesRepo');

@bind(GetPlanCategoriesRepoType)
export class GetPlanCategoriesRepo implements IGetPlanCategoriesRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute() {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/tariff/category_list', { per_page: 1000 }) });

      if (result.status === 200) {
        const data: IPlanCategory[] = result.data.data.map((user) => PlanCategoryMapper.toDomain(user));
        const total: number = result.data.total;

        return {
          status: 200 as 200,
          response: {
            data,
            total,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
